module.exports = __webpack_public_path__ + "assets/img/scope.5bcede17.png";